import { createReducer } from 'store/helpers';
import filter from 'lodash/filter';
import map from 'lodash/map';
import {
  SET_ERROR,
  CLEAR_ERROR,
  REQUEST_STARTED,
  REQUEST_COMPLETED,
  ADD_TEMPLATE,
  SET_TEMPLATES,
  EDIT_TEMPLATE,
  DELETE_TEMPLATE,
  SET_NEW_TEMPLATE_ID,
  SEARCH_IN_TEMPLATES,
} from 'store/actions/templates';
import { addIdPrefix } from 'services/common';

const initialState = {
  templates: [],
  newTemplateId: -1,
  isFetching: false,
  error: '',
  searchTemplatesResults: [],
};

const setError = (state, { error }) =>
  state.merge({ error: addIdPrefix(error) });

const clearError = state => state.merge({ error: '' });

const requestStarted = state => state.merge({ isFetching: true });

const requestCompleted = state => state.merge({ isFetching: false });

const setTemplates = (state, { templates }) => state.merge({ templates });

const addTemplate = (state, { template }) => {
  const templates = [].concat(template, state.templates);
  return state.merge({ templates });
};

const editTemplate = (state, { template }) => {
  const templates = map(state.templates, stateTemplate =>
    stateTemplate.id === template.id ? template : stateTemplate,
  );
  return state.merge({ templates });
};

const deleteTemplate = (state, { templateId }) => {
  const templates = filter(
    state.templates,
    template => template.id !== Number(templateId),
  );
  return state.merge({ templates });
};

const searchInTemplates = (state, { searchString }) => {
  const searchTemplatesResults = state.templates.filter(template => {
    const isAnId = /^\d+$/.test(searchString);
    if (isAnId) {
      return template.id === parseInt(searchString);
    } else {
      return template.name.toLowerCase().includes(searchString.toLowerCase());
    }
  });
  return state.merge({ searchTemplatesResults });
};

const setNewTemplateId = (state, { newTemplateId }) =>
  state.merge({ newTemplateId });

const handlers = {
  [SET_ERROR]: setError,
  [CLEAR_ERROR]: clearError,
  [REQUEST_STARTED]: requestStarted,
  [REQUEST_COMPLETED]: requestCompleted,
  [ADD_TEMPLATE]: addTemplate,
  [SET_TEMPLATES]: setTemplates,
  [EDIT_TEMPLATE]: editTemplate,
  [DELETE_TEMPLATE]: deleteTemplate,
  [SET_NEW_TEMPLATE_ID]: setNewTemplateId,
  [SEARCH_IN_TEMPLATES]: searchInTemplates,
};

export default createReducer(initialState, handlers);
